<template>
  <div class="material-card">
    <div class="card-header">
      <div class="title-wrap">
        <h4 class="title">{{title || '材料题'}}</h4>
      </div>
      <div class="menu-wrap">
        <slot></slot>
      </div>
    </div>
    <div class="exam-material">
      <div class="exam-description">
        <div class="editor-wrap"
             v-html="richText"
             :contenteditable="true"
             ref="content"
             @input="editorInput">
          <input v-for="(item,index) in inputList"
                 :key="index"
                 v-model="item.text" />
        </div>
        <!-- <VueEditor
          :content="richText"
          @change="handleRichTextChange"
          placeholder="请输入材料描述"
        /> -->

      </div>
      <div class="exam-add">
        <div class="exam-buttons">
          <el-button type="primary"
                     @click="handleAddAnswer()">添加答案
          </el-button>
        </div>
      </div>
    </div>
    <specials :visible="dialogVisible"
              @echo="echo"
              :content="content"
              @readName="readName"
              @close="dialogVisible = false">
    </specials>
    <!-- <div class="zhi"
         @click="concatStudy()">选择关联知识点：
      <el-tag v-if="content.readName"> {{content.readName}}</el-tag>
    </div> -->
  </div>
</template>

<script>
import VueEditor from '@/components/VueEditor'

import {} from '@/api/exam'

let Timer = null // 定时器
let TimerTime = 500 // 定时器 等待时长

export default {
  components: {
    VueEditor,
    specials: () => import('@/components/exam/special.vue'),
  },
  props: {
    title: String,
    content: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      richText: '',
      inputIndex: 1,
      inputList: [],
    }
  },
  watch: {
    richText(val) {},
  },
  methods: {
    concatStudy() {
      this.dialogVisible = true
      // this.$refs.childLevelRelevancy.open(this.id, 2)
    },
    readName(val) {
      this.$set(this.content, 'readName', val)
    },
    echo(val, item) {
      this.concatItem = item.name
      this.cncatId = item.id
    },
    // 图文资料
    handleRichTextChange(editor) {
      this.richText = editor.html
      clearTimeout(Timer)
      Timer = setTimeout(() => {}, TimerTime)
    },
    handleAddAnswer() {
      /*    this.inputList.push({
           text: "",
         }) */
      this.$nextTick(() => {
        this.$refs[
          'content'
        ].innerHTML += `<input type='text' class='input-calss'/>`
      })
    },
    editorInput(e) {
      console.log(this.$refs['content'].innerHTML)
      /*    this.$refs["content"].innerHTML = e.data.replace(/[\n\r]/g, '<br>') */
    },
  },
}
</script>

<style scoped lang="less">
.zhi {
  margin-top: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #0091ff;
  font-size: 16px;
}
.material-card {
  position: relative;
  color: #303133;
  background-color: #fff;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  padding: 20px;

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .title-wrap {
      display: flex;

      .title {
        font-size: 18px;
        font-weight: bold;
        color: #0091ff;
        margin-right: 20px;
      }
      /deep/ .el-radio {
        margin-right: 20px;
      }
      /deep/ .el-radio__label {
        padding-left: 5px;
      }
    }
    .menu-wrap {
      display: flex;
      align-items: center;

      /deep/ .el-button {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  }
  .exam-material {
    background: #fff;
    // padding: 20px 0;
    margin: 20px 0;
  }
  .upload-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .tip {
      font-size: 12px;
      color: #999;
      margin-left: 10px;
    }
  }
  .audio-box {
    margin-left: 20px;

    audio {
      outline: none;
    }
  }
  .vueEditor {
    /deep/ .ql-container {
      min-height: 80px;
    }
  }
  .exam-add {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px dashed #0091ff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
    margin-top: 20px;

    display: flex;
    flex-direction: column;
    align-items: center;

    .exam-buttons {
      margin-top: 10px;

      /deep/ .el-button {
        padding: 10px 30px;
        margin: 0 20px;
      }
    }
  }
  .editor-wrap {
    min-height: 200px;
    background: #f5f5f5;
    border-radius: 4px;
    padding: 16px;
    white-space: normal;
  }
}
</style>
<style lang="less">
.input-calss {
  border-bottom: 1px #333 solid;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  background: transparent;
  margin: 0px 8px;
  /*   border-bottom: 1px #333;
  border: 0px; 
  outline: none; 
  background: transparent; */
}
</style>
